import { render } from "./Sidebar.vue?vue&type=template&id=f513e622&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=f513e622&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f513e622"

export default script